<template>
    <div>
        <div v-if="$vuetify.breakpoint.lgAndUp">
            <v-data-table
                :headers="headers"
                :items="outrights"
                :single-expand="singleExpand"
                :expanded.sync="expanded"
                hide-default-footer
                dense
                item-key="id"
                show-expand
                class="elevation-1"
                style="background:#141C2E;"
            >
                <template v-slot:[`item.start`]="{ item }">
                    <div class="py-5"><v-icon :style="{color: item.start == 'LIVE' ? 'red' : item.start == 'CLOSED' ? '' : '#45D25C'}" size="30">mdi-circle-small</v-icon>{{ item.start }}</div>
                </template>
                <template v-slot:[`item.category`]="{ item }">
                    <div><v-img :src="item.category" max-width="30" max-heigth="30" style="margin-left: auto; margin-right: auto;"></v-img></div>
                </template>
                <template v-slot:[`item.leagueName`]="{ item }">
                    <div class="font-weight-bold text-h6">{{item.leagueName}}</div>
                </template>
                <template v-slot:[`item.format`]="{ item }">
                    <div>{{item.format}}</div>
                </template>
                <template v-slot:[`item.number_of_teams`]="{ item }">
                    <div style="color:#D28945">{{item.number_of_teams}}</div>
                </template>

                <template v-slot:expanded-item="{ headers, item }">
                    <td :colspan="headers.length" class="pa-0">
                        <v-card flat color="rgba(13, 17, 27, .5)" class="rounded-b-xl rounded-t-0">
                            <v-row no-gutters>
                                <v-col cols="12" lg="6" :class="$vuetify.breakpoint.mdAndDown ? 'pa-3' : 'expand-content-col-left pa-3'">
                                    <v-row class="expand-content-row-head">
                                        <v-col cols="3" class="px-0"><div class="text-caption">TEAM</div></v-col>
                                        <v-col cols="2" class="px-0"><div class="text-caption">% {RATIO)</div></v-col>
                                        <v-col cols="2" class="px-0"><div class="text-caption">YOUR BET</div></v-col>
                                        <v-col cols="3" class="px-0"><div class="text-caption">POSSIBLE PAYOUT</div></v-col>
                                        <v-col cols="2" class="px-0"></v-col>
                                    </v-row>
                                    <v-row v-for="items in item.first_team" :key="items.id" :style="$vuetify.breakpoint.mdAndDown ? '' : 'height:100px'" class="d-flex align-center expand-content-row">
                                        <v-col cols="3" class="px-0">
                                            <div class="py-1">
                                                <v-img :src="items.team" max-width="35" max-heigth="35" :style="items.status == 'WIN' ? 'margin-left: auto; margin-right: auto;' : 'opacity:25%; margin-left: auto; margin-right: auto;'"></v-img>
                                                <div class="pt-1 text-caption" :style="items.status == 'WIN' ? 'color:#45D28E;' : 'opacity:25%;'"><v-icon v-if="items.status == 'WIN'" x-small class="pr-1" color="#D28945">mdi-crown</v-icon>{{items.team_name}}</div>
                                            </div>
                                        </v-col>
                                        <v-col cols="2" class="px-0"><div class="text-caption" :style="items.status == 'WIN' ? '' : 'opacity:25%;'">{{items.odds}}</div></v-col>
                                        <v-col cols="2" class="px-0"><div class="text-caption" :style="items.status == 'WIN' ? '' : (items.status == 'LOSE' ? 'color:#D24545; opacity:25%;' : 'opacity:25%;')">{{items.bet == null ? '₱ 0' : `₱ ${Number(items.bet).toLocaleString()}` }}</div></v-col>
                                        <v-col cols="3" class="px-0"><div class="text-caption" :style="items.status == 'WIN' ? 'color:#45D28E;' : (items.status == 'LOSE' ? 'color:#D24545; opacity:25%;' : 'opacity:25%;')">{{items.possible == null ? '₱ 0' : `₱ ${Number(items.possible).toLocaleString()}` }}</div></v-col>
                                        <v-col cols="2" class="px-0"><v-chip small rounded color="rgba(134, 136, 141, 0.75)" class="px-4">CLOSED</v-chip></v-col>
                                    </v-row>
                                </v-col>
                                <v-col cols="12" lg="6" :class="$vuetify.breakpoint.mdAndDown ? 'pa-3' : 'expand-content-col-right pa-3'">
                                    <v-row class="expand-content-row-head">
                                        <v-col cols="3" class="px-0"><div class="text-caption">TEAM</div></v-col>
                                        <v-col cols="2" class="px-0"><div class="text-caption">% {RATIO)</div></v-col>
                                        <v-col cols="2" class="px-0"><div class="text-caption">YOUR BET</div></v-col>
                                        <v-col cols="3" class="px-0"><div class="text-caption">POSSIBLE PAYOUT</div></v-col>
                                        <v-col cols="2" class="px-0"></v-col>
                                    </v-row>
                                    <v-row v-for="items in item.second_team" :key="items.id" :style="$vuetify.breakpoint.mdAndDown ? '' : 'height:100px'" class="d-flex align-center expand-content-row">
                                        <v-col cols="3" class="px-0">
                                            <div class="py-1">
                                                <v-img :src="items.team" max-width="35" max-heigth="35" :style="items.status == 'WIN' ? 'margin-left: auto; margin-right: auto;' : 'opacity:25%; margin-left: auto; margin-right: auto;'"></v-img>
                                                <div class="pt-1 text-caption" :style="items.status == 'WIN' ? 'color:#45D28E;' : 'opacity:25%;'"><v-icon v-if="items.status == 'WIN'" x-small class="pr-1" color="#D28945">mdi-crown</v-icon>{{items.team_name}}</div>
                                            </div>
                                        </v-col>
                                        <v-col cols="2" class="px-0"><div class="text-caption" :style="items.status == 'WIN' ? '' : 'opacity:25%;'">{{items.odds}}</div></v-col>
                                        <v-col cols="2" class="px-0"><div class="text-caption" :style="items.status == 'WIN' ? '' : (items.status == 'LOSE' ? 'color:#D24545; opacity:25%;' : 'opacity:25%;')">{{items.bet == null ? '₱ 0' : `₱ ${Number(items.bet).toLocaleString()}` }}</div></v-col>
                                        <v-col cols="3" class="px-0"><div class="text-caption" :style="items.status == 'WIN' ? 'color:#45D28E;' : (items.status == null ? 'opacity:25%;' : 'color:#D24545; opacity:25%;')">{{items.possible == null ? '₱ 0' : `₱ ${Number(items.possible).toLocaleString()}` }}</div></v-col>
                                        <v-col cols="2" class="px-0"><v-chip small rounded color="rgba(134, 136, 141, 0.75)" class="px-4">CLOSED</v-chip></v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                        </v-card>
                    </td>
                </template>
            </v-data-table>
        </div>
        <div v-else>
            <v-list color="#0D111B" class="py-0">
                <v-list-group
                    v-for="item in outrights"
                    :key="item.id"
                    v-model="item.active"
                    :prepend-icon="item.action"
                    no-action
                    color="inherit"
                >
                    <template v-slot:activator>
                        <v-list-item-content>
                            <v-row class="d-flex align-center">
                                <v-col cols="4">
                                    <v-list-item-title>
                                        <div class="text-start" style="font-size: 8px !important;"><v-icon color="#45D28E">mdi-circle-small</v-icon>{{item.start}}</div>
                                    </v-list-item-title>
                                </v-col>
                                <v-col cols="6" class="px-0">
                                    <v-list-item-title>
                                        <div class="text-start font-weight-bold" style="font-size: 10px !important;">{{item.leagueName}}</div>
                                    </v-list-item-title>
                                </v-col>
                                <v-col cols="2">
                                    <v-list-item-title>
                                        <v-img :src="item.category" max-width="15" max-heigth="15" style="margin-left: auto; margin-right: auto; opacity: 50% !important;"></v-img>
                                    </v-list-item-title>
                                </v-col>
                            </v-row>
                        </v-list-item-content>
                    </template>
                    <v-list-item class="px-0" dense>
                        <v-list-item-content style="background: rgba(13, 17, 27, 0.5) !important;">
                            <div v-for="team in item.first_team" :key="team.id">
                                <v-row class="d-flex align-center mr-3 py-3">
                                    <v-col cols="3">
                                        <v-img :src="team.team" max-width="30" max-heigth="30" :style="team.status == 'WIN' ? 'margin-left: auto; margin-right: auto;' : 'margin-left: auto; margin-right: auto; opacity: 25% !important;'"></v-img>
                                        <div class="pt-1 font-weight-bold" :style="team.status == 'WIN' ? 'font-size:10px !important; color:#45D28E !important;' : 'font-size:10px !important; opacity: 25% !important;'"><v-icon v-if="team.status == 'WIN'" x-small class="mr-1" color="#D28945">mdi-crown</v-icon>{{team.team_name}}</div>
                                    </v-col>
                                    <v-col cols="2" class="px-1">
                                        <div style="font-size:10px !important;">{{team.odds}}</div>
                                    </v-col>
                                    <v-col cols="2" class="px-1">
                                        <div style="font-size:10px !important;">₱ {{team.bet != null ? team.bet : '0.00'}}</div>
                                    </v-col>
                                    <v-col cols="2" class="px-1">
                                        <div :style="team.possible == null ? 'font-size:10px !important;' : 'font-size:10px !important; color:#45D28E !important;'">₱ {{team.possible != null ? team.possible : '0.00'}}</div>
                                    </v-col>
                                    <v-col cols="3">
                                        <v-btn x-small color="rgba(134, 136, 141, .75)" rounded style="font-size: 8px !important;">closed</v-btn>
                                    </v-col>
                                </v-row>
                                <v-divider style="border: 1px solid gray !important;"></v-divider>
                            </div>
                        </v-list-item-content>
                    </v-list-item>
                </v-list-group>
            </v-list>
        </div>
    </div>
</template>
<script>
export default {
    data () {
      return {
        tab: null,
        expanded: [],
        singleExpand: true,
        headers: [
            { text: 'Start', align: 'start', class: 'pl-6', sortable: false, value: 'start' },
            { text: 'Category', align: 'center', sortable: false, value: 'category' },
            { text: 'League Name', align: 'center', sortable: false, value: 'leagueName' },
            { text: 'Format', align: 'center', sortable: false, value: 'format' },
            { text: 'Number of Teams', align: 'center', sortable: false, value: `number_of_teams` },
            { text: '', align: 'center', sortable: false, value: `data-table-expand` }
        ],
        outrights: [
            {
                id: 1,
                start: 'CLOSED',
                category_name: 'Dota',
                category: require('@/assets/images/Dota.svg'),
                leagueName: "DPC SEA Tour 3: Division II",
                format: "SINGLE ROUND - ROBIN",
                number_of_teams: "EIGHT TEAMS",
                first_team: [
                    {
                        id: 1,
                        team: require('@/assets/images/Virtus.svg'),
                        team_name: 'Virtus.pro',
                        odds: '31.88% (2.97)',
                        bet: '1250',
                        possible: '3100.50',
                        status: 'WIN'
                    },
                    {
                        id: 2,
                        team: require('@/assets/images/Fnatic.svg'),
                        team_name: 'Fnatic',
                        odds: '26.09% (x3.64)',
                        bet: null,
                        possible: null,
                        status: null
                    },
                    {
                        id: 3,
                        team: require('@/assets/images/Yangon_Galacticos.svg'),
                        team_name: 'Yangon Galacticos',
                        odds: '19.35% (x4.90)',
                        bet: null,
                        possible: null,
                        status: null
                    },
                    {
                        id: 4,
                        team: require('@/assets/images/Boom.svg'),
                        team_name: 'Fnatic',
                        odds: '6.05% (x15.67)',
                        bet: null,
                        possible: null,
                        status: null
                    },
                ],
                second_team: [
                    {
                        id: 5,
                        team: require('@/assets/images/Victory_Five.svg'),
                        team_name: 'Victory Five',
                        odds: '3.37% (x28.16)',
                        bet: '2500',
                        possible: '2800.75',
                        status: 'LOSE'
                    },
                    {
                        id: 6,
                        team: require('@/assets/images/IG.svg'),
                        team_name: 'Invictus Gaming',
                        odds: '2.13% (x44.53)',
                        bet: null,
                        possible: null,
                        status: null
                    },
                    {
                        id: 7,
                        team: require('@/assets/images/Xerxia.svg'),
                        team_name: 'Xerxia Esports',
                        odds: '4.92% (x19.30)',
                        bet: null,
                        possible: null,
                        status: null
                    },
                    {
                        id: 8,
                        team: require('@/assets/images/RRQ.svg'),
                        team_name: 'RRQ',
                        odds: '6.18% (x15.36)',
                        bet: null,
                        possible: null,
                        status: null
                    },
                ],
            },
            {
                id: 2,
                start: 'CLOSED',
                category_name: 'LOL',
                category: require('@/assets/images/LOL.svg'),
                leagueName: "LPL SUMMER LEAGUE",
                format: "SINGLE ROUND - ROBIN",
                number_of_teams: "EIGHT TEAMS",
                first_team: [
                    {
                        id: 9,
                        team: require('@/assets/images/Virtus.svg'),
                        team_name: 'Virtus.pro',
                        odds: '6.18% (x15.36)',
                        bet: '250.00',
                        possible: '742.50',
                        status: 'LOSE'
                    },
                    {
                        id: 10,
                        team: require('@/assets/images/Team_Secret.svg'),
                        team_name: 'Team Secret',
                        odds: '4.92% (x19.30)',
                        bet: '400.00',
                        possible: '650.00',
                        status: 'WIN'
                    },
                    {
                        id: 11,
                        team: require('@/assets/images/Fnatic.svg'),
                        team_name: 'Fnatic',
                        odds: '3.37% (x28.16)',
                        bet: '600.00',
                        possible: '980.00',
                        status: 'WIN'
                    },
                    {
                        id: 12,
                        team: require('@/assets/images/Boom.svg'),
                        team_name: 'Boom Esports',
                        odds: '2.13% (x44.53)',
                        bet: null,
                        possible: null,
                        status: null
                    },
                ],
                second_team: [
                    {
                        id: 13,
                        team: require('@/assets/images/Weibo.svg'),
                        team_name: 'Weibo Gaming',
                        odds: '31.88% (x2.97)',
                        bet: '300.00',
                        possible: '520.00',
                        status: 'WIN'
                    },
                    {
                        id: 14,
                        team: require('@/assets/images/LGD.svg'),
                        team_name: 'LGD Gaming',
                        odds: '6.05% (x15.67)',
                        bet: '250.00',
                        possible: '742.50',
                        status: 'LOSE'
                    },
                    {
                        id: 15,
                        team: require('@/assets/images/Paper_Rex.svg'),
                        team_name: 'Paper Rex',
                        odds: '19.35% (x4.90)',
                        bet: '100.00',
                        possible: '220.00',
                        status: 'LOSE'
                    },
                    {
                        id: 16,
                        team: require('@/assets/images/Xerxia.svg'),
                        team_name: 'Xerxia Esports',
                        odds: '26.09% (x3.64)',
                        bet: null,
                        possible: null,
                        status: null
                    },
                ],
            },
            {
                id: 3,
                start: 'CLOSED',
                category_name: 'Dota',
                category: require('@/assets/images/Dota.svg'),
                leagueName: "DPC CIS Tour 3: Division II",
                format: "SINGLE ROUND - ROBIN",
                number_of_teams: "EIGHT TEAMS",
                first_team: [
                    {
                        id: 17,
                        team: require('@/assets/images/Virtus.svg'),
                        team_name: 'Virtus.pro',
                        odds: '31.88% (2.97)',
                        bet: '250.00',
                        possible: '742.50',
                        status: 'LOSE'
                    },
                    {
                        id: 18,
                        team: require('@/assets/images/Fnatic.svg'),
                        team_name: 'Fnatic',
                        odds: '26.09% (x3.64)',
                        bet: null,
                        possible: null,
                        status: null
                    },
                    {
                        id: 19,
                        team: require('@/assets/images/Yangon_Galacticos.svg'),
                        team_name: 'Yangon Galacticos',
                        odds: '19.35% (x4.90)',
                        bet: null,
                        possible: null,
                        status: null
                    },
                    {
                        id: 20,
                        team: require('@/assets/images/Boom.svg'),
                        team_name: 'Fnatic',
                        odds: '6.05% (x15.67)',
                        bet: null,
                        possible: null,
                        status: null
                    },
                ],
                second_team: [
                    {
                        id: 21,
                        team: require('@/assets/images/Victory_Five.svg'),
                        team_name: 'Victory Five',
                        odds: '3.37% (x28.16)',
                        bet: '250.00',
                        possible: '742.50',
                        status: 'WIN'
                    },
                    {
                        id: 22,
                        team: require('@/assets/images/IG.svg'),
                        team_name: 'Invictus Gaming',
                        odds: '2.13% (x44.53)',
                        bet: null,
                        possible: null,
                        status: null
                    },
                    {
                        id: 23,
                        team: require('@/assets/images/Xerxia.svg'),
                        team_name: 'Xerxia Esports',
                        odds: '4.92% (x19.30)',
                        bet: null,
                        possible: null,
                        status: null
                    },
                    {
                        id: 24,
                        team: require('@/assets/images/RRQ.svg'),
                        team_name: 'RRQ',
                        odds: '6.18% (x15.36)',
                        bet: null,
                        possible: null,
                        status: null
                    },
                ],
            },
        ]
      }
    }
};
</script>
<style scoped>
.v-data-table >>> div > table > tbody > tr > td {
    background-color:rgba(13, 17, 27, .75);
    padding-bottom: 5px !important;
}
.v-data-table >>> div > table > thead > tr > th {
    border: none !important;
}
.v-data-table >>> div > table > tbody > tr > td:nth-child(2) > div > div {
    opacity: 50%;
}
.v-data-table >>> div > table > tbody > tr:hover:not(.v-data-table__empty-wrapper) {
    background-color: rgba(13, 17, 27, 1) !important;
}
.v-data-table >>> div > table > tbody > tr:hover:not(.v-data-table__empty-wrapper) > td:nth-child(2) > div > div {
    opacity: 100%;
}
.v-data-table__expanded__content > td {
    background-color: #141C2E !important;
    border-bottom: none !important;
}
.v-data-table__expanded .v-data-table__expanded__content {
    text-indent: 0;
    border: 1px solid blue !important;
}
.expand-content-row-head {
    border-bottom: 1px solid rgba(255, 255, 255, .5) !important;
}
.expand-content-row {
    border-top: 1px solid rgba(255, 255, 255, .25) !important;
}
.expand-content-col-left {
    border-right: 1px solid rgba(255, 255, 255, .25) !important;
}
.expand-content-col-right {
    border-left: 1px solid rgba(255, 255, 255, .25) !important;
}
</style>